import { useEffect, useState } from "react";
import {TOGGLE_AI_PANEL, coreStore, subscriptionManager} from "@forcepoint/platform-coreui";

const AIAction = (props) => {

    const toggleAIPanel = () => {
        coreStore.dispatch({ type: TOGGLE_AI_PANEL })
    }

    const [alertsCount, setAlertsCount] = useState(coreStore.getState().aiPanel?.alerts?.length || 0)

    // TODO: Integrate this properly
    useEffect(()=>{
        const unsubscribe = subscriptionManager.subscribe(
            coreStore,
            state => state.aiPanel?.alerts,
            (alerts) => setAlertsCount(alerts?.length || 0)
        );
        return () => {
            unsubscribe();
        };
    },[])

    return (
        <li>
            <button onClick={toggleAIPanel} className="ai-action-button" aria-label="Ask ARIA">
                {/* White sparkle — same artwork as the inner glyph of the
                    ARIA logo, without the surrounding circle. The button's
                    own purple background plays the role of the logo's
                    circle, so the sparkle reads as a mini ARIA mark. */}
                <svg
                    className="ai-action-button__icon"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <g clipPath="url(#ai_action_sparkle_clip)">
                        <path
                            d="M5.79651 9.04165C5.74443 8.83977 5.6392 8.65554 5.49178 8.50812C5.34436 8.3607 5.16013 8.25548 4.95826 8.2034L1.37951 7.28057C1.31845 7.26324 1.26471 7.22646 1.22645 7.17583C1.18818 7.12519 1.16748 7.06345 1.16748 6.99998C1.16748 6.93651 1.18818 6.87478 1.22645 6.82414C1.26471 6.7735 1.31845 6.73673 1.37951 6.7194L4.95826 5.79598C5.16006 5.74395 5.34424 5.63882 5.49166 5.49151C5.63907 5.34419 5.74434 5.16008 5.79651 4.95832L6.71934 1.37957C6.7365 1.31827 6.77323 1.26427 6.82394 1.2258C6.87466 1.18733 6.93656 1.1665 7.00022 1.1665C7.06387 1.1665 7.12577 1.18733 7.17649 1.2258C7.2272 1.26427 7.26394 1.31827 7.28109 1.37957L8.20334 4.95832C8.25542 5.16019 8.36064 5.34442 8.50806 5.49184C8.65548 5.63926 8.83972 5.74449 9.04159 5.79657L12.6203 6.71882C12.6819 6.73579 12.7362 6.77249 12.7748 6.82328C12.8135 6.87407 12.8345 6.93614 12.8345 6.99998C12.8345 7.06382 12.8135 7.1259 12.7748 7.17669C12.7362 7.22748 12.6819 7.26417 12.6203 7.28115L9.04159 8.2034C8.83972 8.25548 8.65548 8.3607 8.50806 8.50812C8.36064 8.65554 8.25542 8.83977 8.20334 9.04165L7.28051 12.6204C7.26335 12.6817 7.22662 12.7357 7.1759 12.7742C7.12519 12.8126 7.06329 12.8335 6.99963 12.8335C6.93598 12.8335 6.87407 12.8126 6.82336 12.7742C6.77265 12.7357 6.73591 12.6817 6.71876 12.6204L5.79651 9.04165Z"
                            stroke="currentColor"
                            strokeWidth="1.16667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M11.6665 1.75V4.08333" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12.8333 2.91675H10.5" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M2.3335 9.91675V11.0834" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M2.91667 10.5H1.75" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="ai_action_sparkle_clip">
                            <rect width="14" height="14" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <span className="ai-action-button__label">Ask ARIA</span>
                {alertsCount > 0 ? (
                    <span className="indicator green">{alertsCount}</span>
                ) : null}
            </button>
        </li>
    )
};

export default AIAction;